/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.sunnahsky.article.assets'

type $nsid = typeof $nsid

export { $nsid }

/** Blob references for images embedded in an article body. Exists solely so those blobs are tethered to the repo: atproto only promotes a blob out of temporary storage when a record field of type blob references it, and an article body carries its images as markdown URLs, not as record fields, so without this record they would never be tethered and com.atproto.sync.getBlob would 404 on them forever. Written atomically alongside the site.standard.document it belongs to, and sharing that document's rkey so it can be located on edit without a scan. THIS IS A TEMPORARY UNSPECCED LEXICON, specific to this fork's article-authoring feature. */
type Main = {
  $type: 'com.sunnahsky.article.assets'

  /**
   * The site.standard.document whose body embeds these images.
   */
  document: l.AtUriString

  /**
   * Every image still referenced by the document's markdown at the time of writing. Must be complete on every write: a blob dropped from this list is dereferenced and then permanently deleted from the blobstore, so an update that omits an image still present in the body destroys it irrecoverably.
   */
  images: Image[]
}

export type { Main }

/** Blob references for images embedded in an article body. Exists solely so those blobs are tethered to the repo: atproto only promotes a blob out of temporary storage when a record field of type blob references it, and an article body carries its images as markdown URLs, not as record fields, so without this record they would never be tethered and com.atproto.sync.getBlob would 404 on them forever. Written atomically alongside the site.standard.document it belongs to, and sharing that document's rkey so it can be located on edit without a scan. THIS IS A TEMPORARY UNSPECCED LEXICON, specific to this fork's article-authoring feature. */
const main = /*#__PURE__*/ l.record<'tid', Main>(
  'tid',
  $nsid,
  /*#__PURE__*/ l.object({
    document: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    images: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<Image>((() => image) as any),
      { maxLength: 30 },
    ),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

type Image = {
  $type?: 'com.sunnahsky.article.assets#image'

  /**
   * Comfortably under the PDS's own 5MB blobUploadLimit. Decimal bytes, matching the convention already used by app.bsky.embed.images and com.sunnahsky.article.draft.defs#draft.coverImage.
   */
  image: l.BlobRef
}

export type { Image }

const image = /*#__PURE__*/ l.typedObject<Image>(
  $nsid,
  'image',
  /*#__PURE__*/ l.object({
    image: /*#__PURE__*/ l.blob({ accept: ['image/*'], maxSize: 3000000 }),
  }),
)

export { image }
